import { unmountComponentAtNode } from "react-dom";
import { createRoot } from "react-dom/client";

import Confirmation from "./Confirmation";

const createWrapperAndAppendToBody = (wrapperId: string) => {
  const wrapperElement = document.createElement("div");
  wrapperElement.setAttribute("id", wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
};

const confirm = (
  title: string,
  message?: string,
  noLabel?: string,
  yesLabel?: string
) => {
  let element = document.getElementById("confirmation-modal");
  let root: ReturnType<typeof createRoot>;
  // if element is not found with wrapperId,
  // create and append to body
  if (!element) {
    element = createWrapperAndAppendToBody("confirmation-modal");
  }

  const dispose = () => {
    if (root) {
      root.unmount();
      element && unmountComponentAtNode(element);
    }
  };

  const promise = new Promise((resolve, reject) => {
    try {
      if (!root) root = createRoot(element as Element);
      root.render(
        <Confirmation
          title={title}
          message={message}
          noLabel={noLabel}
          yesLabel={yesLabel}
          resolve={resolve}
          reject={reject}
        />
      );
    } catch (error) {
      throw error;
    }
  });

  return promise.then(
    () => {
      dispose();
      return true;
    },
    () => {
      dispose();
      return false;
    }
  );
};

export default confirm;
